import script from "./RecordList.vue?vue&type=script&setup=true&lang=js"
export * from "./RecordList.vue?vue&type=script&setup=true&lang=js"

import "./RecordList.vue?vue&type=style&index=0&id=a51ed390&scoped=true&lang=css"

import exportComponent from "D:\\projects\\mitool\\MITOOL\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a51ed390"]])

export default __exports__